(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sso', {
            parent: 'app',
            url: '/sso/{accessKey}?appraisalOrderId&edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', 'Integration', 'LenderIntegrationBlacklist', 'Auth', 'User', 'AlertService', 'Principal', '$window', '$log', 'ProfileService', function($stateParams, $state, Integration, LenderIntegrationBlacklist, Auth, User, AlertService, Principal, $window, $log, ProfileService) {
                var v2AuthBaseUrl = '';
                ProfileService.getProfileInfo().then(function(response) {
                    v2AuthBaseUrl = response.v2AuthBaseUrl || '';
                });

                Integration.verifySSO({ accessKey: $stateParams.accessKey }).$promise
                    .then(function() {
                        return Auth.authorize(true);
                    }).then(function() {
                        Principal.identity().then(function(user){
                            if ($stateParams.appraisalOrderId) {
                                var target = $stateParams.edit === true || $stateParams.edit === 'true' ? 'appraisal-order.edit' : 'appraisal-order-detail';
                                return $state.go(target, { 'id' : $stateParams.appraisalOrderId, 'isSSO': true});
                            } else {
                                return $state.go('appraisal-order.new');
                            }

                        });
                    }).catch(function(err) {
                        AlertService.error("error.sso.invalid", {});
                        Auth.logout().then(function() {
                            $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
                        }).catch(function(error) {
                            $log.warn('Logout failed:', error);
                            $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
                        });
                    });
            }]
        })
        .state('authorize-grant-request', {
            parent: 'app',
            url: '/grant-request/{token}?integrationName',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', 'Integration', 'Auth', 'AlertService', 'Principal', '$window', '$log', 'ProfileService', function($stateParams, $state, Integration, Auth, AlertService, Principal, $window, $log, ProfileService) {
                var v2AuthBaseUrl = '';
                ProfileService.getProfileInfo().then(function(response) {
                    v2AuthBaseUrl = response.v2AuthBaseUrl || '';
                });

                Integration.authorizeGrantRequest({ token: $stateParams.token }).$promise
                    .then(function(resp) {
                        $log.log(resp.translation);
                        AlertService.success(resp.translation, {});
                        return $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
                    }).catch(function(err) {
                        AlertService.error("error.sso.invalid", {});
                        Auth.logout().then(function() {
                            $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
                        }).catch(function(error) {
                            $log.warn('Logout failed:', error);
                            $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
                        });
                    });
            }]
        });
    }
})();
